import React, { useState } from "react";
import { IconButton, Drawer, List, ListItem, ListItemText, Button } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    display: "none",
    color: "rgba(255, 255, 255, 0.7)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    background: "rgba(255, 255, 255, 0.05)",
    "&:hover": { background: "rgba(255, 255, 255, 0.1)" },
    [theme.breakpoints.down("sm")]: { display: "inline-flex" },
  },
  drawer: {
    "& .MuiDrawer-paper": {
      width: "100%",
      maxWidth: 320,
      background: "rgba(0, 0, 0, 0.95)",
      backdropFilter: "blur(24px) saturate(1.4)",
      borderLeft: "1px solid rgba(255, 255, 255, 0.06)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2.5, 2.5),
    borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#ffffff",
    fontWeight: 800,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    fontSize: "0.95rem",
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: "linear-gradient(130deg, #58EFFE, #39F3CC)",
    boxShadow: "0 0 16px rgba(88, 239, 254, 0.4)",
  },
  closeButton: {
    color: "rgba(255, 255, 255, 0.5)",
    "&:hover": { color: "#ffffff" },
  },
  list: { padding: theme.spacing(2, 0) },
  listItem: {
    padding: theme.spacing(1.5, 2.5),
    color: "rgba(255, 255, 255, 0.7)",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.05)",
      color: "#ffffff",
    },
  },
  loginWrap: {
    padding: theme.spacing(2, 2.5),
    borderTop: "1px solid rgba(255, 255, 255, 0.06)",
  },
  loginButton: {
    width: "100%",
    textTransform: "none",
    fontWeight: 700,
    color: "#000000",
    borderRadius: 14,
    padding: theme.spacing(1.2, 2),
    fontSize: "0.92rem",
    background: "linear-gradient(135deg, #58EFFE 0%, #39F3CC 100%)",
    boxShadow: "0 4px 20px rgba(88, 239, 254, 0.25)",
    "&:hover": {
      background: "linear-gradient(135deg, #3dd4e8 0%, #2dd8b0 100%)",
      boxShadow: "0 6px 28px rgba(88, 239, 254, 0.4)",
    },
  },
}));

export default function MobileNav({ navItems, resolveText, onLogin }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton className={classes.menuButton} size="small" onClick={() => setOpen(true)}>
        <MenuIcon fontSize="small" />
      </IconButton>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} className={classes.drawer}>
        <div className={classes.header}>
          <div className={classes.brand}>
            <span className={classes.dot} />
            <span>Klorum</span>
          </div>
          <IconButton className={classes.closeButton} size="small" onClick={() => setOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <List className={classes.list}>
          {navItems.map((item) => (
            <ListItem
              button
              key={item.id}
              className={classes.listItem}
              component="a"
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
            >
              <ListItemText primary={resolveText(item.labelKey)} />
            </ListItem>
          ))}
        </List>

        <div className={classes.loginWrap}>
          <Button
            className={classes.loginButton}
            startIcon={<ExitToAppIcon fontSize="small" />}
            onClick={() => { setOpen(false); onLogin(); }}
          >
            {resolveText("landing.actions.login")}
          </Button>
        </div>
      </Drawer>
    </>
  );
}
